import React from 'react';

interface Props {
  minWidth?: string;
}

export function ButtonMinWidth(props: Props) {
  const { minWidth } = props;

  if (!minWidth) {
    return null;
  }

  return (
    <img
      ref={(node) => {
        node?.style.setProperty('width', minWidth, 'important');
        node?.style.setProperty('max-width', '100%', 'important');
      }}
      height="1"
      style={{
        display: 'block',
        height: '1px',
        maxHeight: '1px',
      }}
      src="https://static.wixstatic.com/media/8f5152_9c9b518c839548d68838a8d097857b62~mv2.gif"
      alt=""
    />
  );
}
